import React from 'react';
import classNames from 'classnames';
import { SafeAreaWrap,Icon } from '@beisen/chaos-ui';
import * as helper from '../util/helper';
import { getConnectSymbol,serializeUrl } from '../util/url';
require('./popViewButton.scss');
class PopViewButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleCancel(e) {
        e && e.preventDefault();
        if(window.env.platform.iTalentIOS) {
            window.env.trigger({
                name: 'iTalentIOS_pop_indexview_cancel'
            });
            window.env.closePage();
            return;
        }
        
        window.iTalentSDK.sendMessage({
            publishEvent: 'pop_indexview_cancel'
        });
    }

    parseParams(stringParams) {
        if(!stringParams) return {};
        const params = {};
        stringParams.split(',').forEach(kv => {
            let items = kv.split(':');
            const key = items[0].trim();
            params[key] = items.length > 2 ? items[1].concat(':', items[2]) : items[1];
        });
        return params;
    }
    // 发送给业务的数据
    formatSubmitData() {
        const { searchData,pageData,globleChecked,selectIds,selectData } = this.props;
        if(!globleChecked && !selectIds) return;
        let submitObj = {};
        if(globleChecked) {
            submitObj = {
                pageData: pageData,
                searchData: searchData
            };
        }else {
            submitObj = {
                selectedIds: selectIds,
                selectedData: selectData
            };
        }
        return submitObj;
    }

    postData(data) {
        // 传递给微服务的数据
        const { globleChecked } = this.props;
        return globleChecked ? data : { ids: data.selectedIds };
    }

    saveMethod() {
        const { popButtonData } = this.props;
        const ajaxParams = helper.getAjaxListParams(popButtonData,'formSaveUrl');
        return ajaxParams.method || 'POST';
    }

    postParams(data) {
        const { popButtonData } = this.props;
        const ajaxParams = helper.getAjaxListParams(popButtonData,'formSaveUrl');
        const token = ajaxParams ? helper.getFeatureToken(ajaxParams) : null;
        let postParams = {
            method: this.saveMethod(),
            body: JSON.stringify(this.postData(data))
        };
        token && (postParams['headers'] = { 'FeatureToken': token });
        return postParams;
    }

    saveData(data = {}) {
        const { popButtonData,translation } = this.props;
        const buttonParams = this.parseParams(popButtonData.cmp_data.params);
        let formSaveUrl = buttonParams.formSaveUrl;

        if(!formSaveUrl) {
            this.props.actions.showTip({
                type: 'error',
                error: { isAutomaticCloseTip: false, code: 500,message: translation.saveError }
            });
            return;
        }

        let fetchParams = {};
        const method = this.saveMethod();
        if(method.toUpperCase() == 'GET') {
            formSaveUrl = formSaveUrl + getConnectSymbol(formSaveUrl) + serializeUrl(this.postData(data));
        }else {
            fetchParams = this.postParams(data);
        }
        
        const successCallBack = function(response) {
            // 保存微服务执行成功 关闭弹窗 发送消息
            const tipInfo = { message: response.message, type: 'success',code: response.code };
            this.props.actions.showTip(tipInfo);
            if(window.env.platform.iTalentIOS) {
                window.env.trigger({
                    name: 'iTalentIOS_pop_indexview_save_success',
                    extra: {
                        data: data
                    }
                });
                setTimeout(() => {
                    this.handleCancel();
                },2500);
                return;
            }
            this.handleCancel();
            window.iTalentSDK.sendMessage({
                publishEvent: 'pop_indexview_save_success',
                data: data
            });
        }.bind(this);

        const failureCallBack = function(error) {
            let tipInfo = { type: 'error', error: Object.assign({},error,{ isAutomaticCloseTip: false, code: error.code || 500 }) };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.actions.showTip(tipInfo);
        }.bind(this);

        window.CommonFetch && window.CommonFetch(formSaveUrl,fetchParams, successCallBack, failureCallBack);
    }

    handleSave(e) {
        e.preventDefault();
        const { globleChecked,selectIds } = this.props;
        if(!globleChecked && !selectIds) return;
        const submitData = this.formatSubmitData();
        if(this.props.popButtonData.extensionSave) {
            // 如果有扩展保存逻辑则不走标准微服务保存 仅发送消息
            if(window.env.platform.iTalentIOS) {
                window.env.trigger({
                    name: 'iTalentIOS_pop_indexview_save',
                    extra: {
                        data: submitData
                    }
                });
                return;
            }
            window.iTalentSDK.sendMessage({
                publishEvent: 'pop_indexview_save',
                data: submitData
            });
            return;
        }
        this.saveData(submitData);
    }

    handleSelectAll(e) {
        this.props.selectAll && this.props.selectAll(e);
    }
    
    render() {
        const { hasGlobleCheck,globleChecked,selectIds,popButtonData,translation } = this.props;
        const { formCanelLabel,formSaveLabel } = this.parseParams(popButtonData.cmp_data.params);

        return (<SafeAreaWrap safeAreaStyle={{ background: '#fff',zIndex: 2,position: 'relative' }}>
                    <div className={classNames('popviewbtn',{ 'no-left': !hasGlobleCheck })}>
                        {hasGlobleCheck ? <div className="pop-btn-left border-1px" onTouchTap={this.handleSelectAll}>
                            <Icon size='small' className='pop-check' icon={classNames({ 'm-sys-checkbox': !globleChecked
                                                                            , 'm-sys-checkbox-active': globleChecked })} />
                            <span className="pop-select-all">{translation.checkAll}</span>
                        </div> : null}
                        <div className="pop-btn-right">
                            <span className="pop-cancel border-1px" onTouchTap={this.handleCancel}>{formCanelLabel || translation.cancel}</span>
                            <span className={classNames('pop-save',{ 'save-able': globleChecked || selectIds })} onTouchTap={this.handleSave}>{formSaveLabel || translation.confirm}</span>
                        </div>
                    </div>
                </SafeAreaWrap>);
    }
       
}

PopViewButton.defaultProps = {
    cmp_data: {},
    selectData: []
};
export default PopViewButton;



// WEBPACK FOOTER //
// ./src/components/PopIndexView/PopViewButton.js